import React from "react";

const AuthIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="197.794"
      height="232.535"
      viewBox="0 0 197.794 232.535"
    >
      <defs>
        <style>
          {
            "\
        .prefix__cls-3{\
            fill:#919191;\
        }\
      "
          }
        </style>
      </defs>
      <g
        id="prefix__Layer_2"
        data-name="Layer 2"
        transform="translate(-30.335 -35.66)"
      >
        <g
          id="prefix__Capa_1"
          data-name="Capa 1"
          transform="translate(30.335 35.66)"
        >
          <g
            id="prefix__Group_28"
            data-name="Group 28"
            transform="translate(81.376 22.151)"
            style={{ Opacity: 0.44 }}
          >
            <path
              id="prefix__Path_109"
              d="M238.883 145.77c-6.8 7.671-15.891 11.451-27.818 11.557h-.539c-11.884-.106-21.014-3.891-27.765-11.557-17.133-19.228-13.449-56.123-13.4-56.431 0-.164.053-.323.053-.433C171.2 50.16 198.694 46 210.473 46h.65c14.586.323 39.38 6.26 41.056 42.891a1.054 1.054 0 0 0 .053.433c.068.376 3.833 37.093-13.349 56.446z"
              data-name="Path 109"
              transform="translate(-168.996 -46)"
              style={{ fill: "#efe1c4" }}
            />
          </g>
          <path
            id="prefix__Path_110"
            d="M150.426 125.3h1.541c14.109-.241 25.522-5.2 33.948-14.687 18.539-20.9 15.457-56.725 15.12-60.144C199.832 24.8 187.7 12.52 177.681 6.79A53.539 53.539 0 0 0 151.775 0h-.819a53.622 53.622 0 0 0-25.907 6.6c-10.064 5.73-22.44 18.01-23.644 43.868-.337 3.419-3.419 39.245 15.12 60.144 8.375 9.488 19.792 14.443 33.901 14.688zm-36.163-73.631c0-.144.048-.289.048-.385 1.589-34.526 26.1-38.234 36.6-38.234h.578c13 .289 35.1 5.586 36.6 38.234a.963.963 0 0 0 .048.385c.048.337 3.419 33.082-11.894 50.321-6.067 6.838-14.157 10.209-24.8 10.3h-.482c-10.594-.1-18.732-3.467-24.751-10.3-15.265-17.143-11.99-50.032-11.942-50.321z"
            class="prefix__cls-3"
            data-name="Path 110"
            transform="translate(-52.372)"
          />
          <path
            id="prefix__Path_111"
            d="M197.784 319.129v-.144c0-.385-.048-.77-.048-1.2-.289-9.534-.915-31.83-21.814-38.956-.144-.048-.337-.1-.482-.144-21.717-5.538-39.775-18.058-39.968-18.2a6.5 6.5 0 1 0-7.465 10.643c.819.577 19.985 13.915 43.965 20.079 11.22 4 12.472 15.987 12.809 26.966a9.672 9.672 0 0 0 .048 1.2 87.409 87.409 0 0 1-1.011 14.88c-7.8 4.43-38.379 19.743-84.9 19.743-46.324 0-77.094-15.361-84.943-19.791a82.747 82.747 0 0 1-1.011-14.88c0-.385.048-.77.048-1.2.337-10.979 1.589-22.969 12.809-26.966 23.981-6.164 43.146-19.55 43.964-20.08a6.5 6.5 0 1 0-7.465-10.643c-.192.146-18.153 12.666-39.967 18.2-.193.048-.337.1-.482.144C.965 285.951.353 308.246.064 317.732a9.67 9.67 0 0 1-.048 1.2v.144c-.048 2.5-.1 15.361 2.456 21.814a6.178 6.178 0 0 0 2.5 3.034c1.445.963 36.067 23.018 94 23.018s92.552-22.1 94-23.018a6.443 6.443 0 0 0 2.5-3.034c2.408-6.4 2.36-19.257 2.312-21.761z"
            class="prefix__cls-3"
            data-name="Path 111"
            transform="translate(-.003 -134.411)"
          />
        </g>
      </g>
    </svg>
  );
};
export default AuthIcon;
